import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@gan/core/util-environment';

import { TrainModel } from '../models';
import { TrainCardService as BaseTrainCardService } from '@gan/common/data-train-card';
import { MethodTypeEnum, useNotification } from '@gan/common/ui-notification';

/**
 * train card service
 */
@Injectable()
export class TrainCardService extends BaseTrainCardService {
  protected override http = inject(HttpClient);

  /**
   * get train info
   * @param serviceId the service id
   */
  // The staff API returns a slimmer train than the common TrainCardService promises its consumers
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override getTrain(serviceId: string): Observable<any> {
    return this.http.get<TrainModel>(`${environment.STAFF_URL}/train-card/${serviceId}`).pipe(
      useNotification({ method: MethodTypeEnum.GET, resourceName: 'Train Info' }),
      map((res) => {
        return { ...res };
      })
    );
  }
}
